module.exports = __webpack_public_path__ + "img/circularityScore.4d2c4998.jpg";